<template>
  <modal :show.sync="showModal" size="lg">
    <h6 slot="header" class="modal-title">Editar Equipo: {{fetchTeam.name}}</h6>
    <form class="needs-validation" id="formEditTeam"
        @submit.prevent="sendForm">
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre"
                      name="nombre"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre')"
                      v-validate="'required'"
                      v-model="team.name">
          </base-input>
        </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Sucursal:">
                    <el-select v-model="team.sucursal.value" filterable
                                placeholder="Seleccione Sucursal">
                        <el-option v-for="option in selectSucursales"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <base-alert v-if="$can('update sponsor', 'teams')" type="warning" dismissible>
          <span class="alert-inner--icon"><i class="ni ni-bulb-61"></i></span>
          <span class="alert-inner--text"> <strong>Cuidado!</strong> Si cambias de sponsor a el equipo, éste quedará sin permisos.</span>
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
          </button>
      </base-alert>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Sponsor:">
                    <el-select @change="loadSucursalList" v-model="team.sponsor.value" filterable
                                placeholder="Seleccione Sucursal">
                        <el-option v-for="option in selectSponsors"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <h3>Permisos del equipo</h3>
      <div class="container">
        <div class="form-row">
          <base-input label="Permisos predefinidos:">
                    <el-select @change="loadPermisosPredefinidos" v-model="predefinido" filterable
                                placeholder="Permisos predefinidos disponibles...">
                        <el-option v-for="option in selectPermisosPredefinidos"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
        </div>
        <div class="form-row" v-for="(atributo,index) in Object.keys(permisos)" :key="index">
          <h4>{{atributo | capitalize}}</h4>
          <div class="col-md-12 d-flex flex-wrap">
            <base-checkbox v-for="(item,indice) in Object.keys(permisos[atributo])" :key="indice" class="mb-3 mr-2" v-model="permisos[atributo][item]">
                {{item}}
            </base-checkbox>
          </div>
        </div>
      </div>
      <!--
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Permisos">
                    <el-select v-model="team.permisos"
                                multiple
                                filterable
                                placeholder="Permisos...">
                        <el-option v-for="option in selectPermisos"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      -->
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formEditTeam">Guardar Cambios</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>

  </modal>
</template>
<script>
import { Select, Option } from 'element-ui';

  export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
      return {
        validated: false,
        team: {
          name: '',
          usuarios: [],
          permisos: [],
          sucursal: {},
          sponsor: {}
        },
        fetchTeam: {
          name: '',

        },
        showModal: false,
        change_password: "0",
        reglasConfirmacion: '',
        reglasPassword: '',
        team_id: null,
        selectUsuarios: [], // Este debe ser un arreglo de objetos asi: { label: ...(es lo que se ve), value: ...}
        selectPermisos: [],
        selectSucursales: [],
        selectSponsors: [],
        permisos: {},
        predefinido: 0,
        selectPermisosPredefinidos: [
          { label: 'Ninguno', value: 0 },
          { label: 'Sólo Ventas', value: 1 },
          { label: 'Vendedor', value: 2 },
          { label: 'Jefe de Tienda', value: 3 },
          { label: 'Administrador Sponsor', value: 4 }
        ],
        permisosSoloVentas: [
        ],
        permisosVendedor: [
          { entidad: 'siniestros', permiso: 'show management' },
          { entidad: 'siniestros', permisos: 'all sponsors'},
          { entidad: 'siniestros', permisos: 'venta propia' },
          { entidad: 'siniestros', permisos: 'venta sponsor' },
        ],
        permisosJefeTienda: [
          { entidad: 'users', permiso: 'show management' },
          { entidad: 'users', permiso: 'create' },
          { entidad: 'users', permiso: 'update equipo' },
          { entidad: 'users', permiso: 'update' },
          /*{ entidad: 'equipos', permiso: 'show management' },
          { entidad: 'equipos', permiso: 'create' },
          { entidad: 'equipos', permiso: 'update' },*/
          { entidad: 'siniestros', permiso: 'show management' },
          //{ entidad: 'reportes', permiso: 'show siniestro' },
          { entidad: 'reportes', permiso: 'show sponsor' },
          //{ entidad: 'reportes', permiso: 'show company' },
          //{ entidad: 'siniestros', permisos: 'all sponsors'},
          { entidad: 'siniestros', permisos: 'venta sponsor' },
        ],
        permisosAdministradorSponsor: [
          { entidad: 'users', permiso: 'show management' },
          { entidad: 'users', permiso: 'update sucursal' },
          { entidad: 'users', permiso: 'create' },
          { entidad: 'users', permiso: 'update equipo' },
          { entidad: 'users', permiso: 'update' },
          { entidad: 'equipos', permiso: 'show management' },
          { entidad: 'equipos', permiso: 'update permisos' },
          { entidad: 'equipos', permiso: 'update sucursal' },
          { entidad: 'equipos', permiso: 'update' },
          { entidad: 'equipos', permiso: 'create' },
          { entidad: 'sucursales', permiso: 'show management' },
          { entidad: 'sucursales', permiso: 'create' },
          { entidad: 'sucursales', permiso: 'update' },
          { entidad: 'planes', permiso: 'show management' },
          { entidad: 'planes', permiso: 'create' },
          { entidad: 'planes', permiso: 'update company' },
          { entidad: 'planes', permiso: 'update categoria' },
          { entidad: 'planes', permiso: 'update subcategoria' },
          { entidad: 'materias', permiso: 'create' },
          { entidad: 'materias', permiso: 'update' },
          { entidad: 'materias', permiso: 'show management' },
          { entidad: 'categorias', permiso: 'show management' },
          { entidad: 'categorias', permiso: 'create' },
          { entidad: 'categorias', permiso: 'update' },
          { entidad: 'subcategorias', permiso: 'show management' },
          { entidad: 'subcategorias', permiso: 'create' },
          { entidad: 'subcategorias', permiso: 'update' },
          { entidad: 'siniestros', permiso: 'show management' },
          { entidad: 'siniestros', permisos: 'venta sponsor' },
          { entidad: 'reportes', permiso: 'show siniestro' },
          { entidad: 'reportes', permiso: 'show sponsor' },
          { entidad: 'reportes', permiso: 'show company' },
          { entidad: 'reportes', permiso: 'all sponsors' },
          { entidad: 'reportes', permiso: 'all companies' },
        ]
      }
    },
    methods: {
      loadPermisosPredefinidos()
      {
        if( this.predefinido ){
          Object.keys(this.permisos).forEach( entidad => {
            Object.keys(this.permisos[entidad]).forEach( permiso => {
              this.permisos[entidad][permiso] = false;
            });
          });
          switch( this.predefinido ){
            case 1 :
              this.permisosSoloVentas.forEach( e => { this.setPermiso(e.entidad, e.permiso) } );
              break;
            case 2 :
              this.permisosVendedor.forEach( e => { this.setPermiso(e.entidad, e.permiso) } );
              break;
            case 3 :
              this.permisosJefeTienda.forEach( e => { this.setPermiso(e.entidad, e.permiso) } );
              break;
            case 4 :
              this.permisosAdministradorSponsor.forEach( e => { this.setPermiso(e.entidad, e.permiso) } );
              break;
          }
        }else{
          Object.keys(this.permisos).forEach( entidad => {
            Object.keys(this.permisos[entidad]).forEach( permiso => {
              this.permisos[entidad][permiso] = false;
            });
          });
        }
      },
      setPermiso(entidad, permiso)
      {
        if( Object.keys(this.permisos).find( key => key == entidad ) ){
          if( Object.keys(this.permisos[entidad]).find( llave => llave == permiso ) ){
            this.permisos[entidad][permiso] = true;
          }
        }
      },
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      sendForm(){
        var vm = this;
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          
          if( response ){
            var arregloPermisos = [];
            Object.keys(vm.permisos).forEach( (entidad,index) => {
              Object.keys(vm.permisos[entidad]).forEach( (permiso, indice) =>{
                if( vm.permisos[entidad][permiso] ) arregloPermisos.push(permiso+' '+entidad);
                
              });
            });
            vm.axios({
                method: 'PUT',
                url: 'api/edit_team',
                data: {   
                          team: vm.team.id, 
                          name: vm.team.name,
                          permisos: arregloPermisos,
                          sucursal: vm.team.sucursal.value
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Equipo editado exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModal = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo modificar el equipo',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
          
        }).catch( reason => {
          console.log(reason);
        });
      },
      fetchDataTeam(team_id)
      {
        var vm = this;
        
        return this.axios({
            method: 'GET',
            url: 'api/edit_team?team='+team_id
        }).then(response => {
            this.fetchTeam.name = this.team.name = response.data.name;
            this.fetchTeam.id = this.team.id = response.data.id;
            //this.team.permisos = response.data.permisos.map( elem => elem.value );
            //this.selectPermisos = response.data.permisosSponsor;
            vm.permisos = {};
            Object.keys(response.data.permisosSponsor).forEach( (entidad, index) => {
              vm.permisos[entidad] = {};
              response.data.permisosSponsor[entidad].forEach( (permiso, indice) => {
                vm.permisos[entidad][permiso] = false;
              });
            });
            Object.keys( response.data.permisos ).forEach( (entidad,index) => {
              response.data.permisos[entidad].forEach( (permiso, indice) => {
                vm.permisos[entidad][permiso] = true;
              });
            });
            this.selectSucursales = response.data.sucursales;
            this.selectSponsors = response.data.sponsors;
            this.team.sponsor = response.data.sponsor;
            this.team.sucursal = response.data.sucursal;
            this.showModal = true;
            this.team_id = team_id;
        }).catch( error => {
            console.log(error);
        })
        ;
      },
      loadSucursalList()
      {
        console.log('se va a llamar a buscar lista de sucursales del sponsor');
        var vm = this;
        this.axios({
          method: 'POST',
          url: 'api/list_sponsorbranchs_from_sponsor',
          data: {sponsor: this.team.sponsor.value}
        }).then( response => {
          vm.selectSucursales = response.data;
          vm.team.sucursal.value = undefined;
        }).catch( error => {
          console.log(error);
        }); 
      }
    },
    mounted()
    {
        
    },
    created()
    {
      this.$parent.$on('loadModalEditTeam', (team_id) => { this.fetchDataTeam(team_id) } );
    },
  }
</script>
<style>
</style>
